import { VariableValuesObject } from '@optimizely/react-sdk/dist/client'
import findIndex from 'lodash/findIndex'
import range from 'lodash/range'

import { usePricingModelFeatureSlot } from '@/optimizely/features/pricing-model-feature-slots/hooks'

const NUMBER_OF_SLOTS = 6
const SLOT_ITERATEE = range(1, NUMBER_OF_SLOTS + 1)

const usePricingFeatureSlots = (
    categoryId: number,
    subCategoryId: number,
): {
    enabled: boolean
    variables: VariableValuesObject | undefined
} => {
    const [enabledSlot1, variablesSlot1] = usePricingModelFeatureSlot(SLOT_ITERATEE[0], categoryId, subCategoryId)
    const [enabledSlot2, variablesSlot2] = usePricingModelFeatureSlot(SLOT_ITERATEE[1], categoryId, subCategoryId)
    const [enabledSlot3, variablesSlot3] = usePricingModelFeatureSlot(SLOT_ITERATEE[2], categoryId, subCategoryId)
    const [enabledSlot4, variablesSlot4] = usePricingModelFeatureSlot(SLOT_ITERATEE[3], categoryId, subCategoryId)
    const [enabledSlot5, variablesSlot5] = usePricingModelFeatureSlot(SLOT_ITERATEE[4], categoryId, subCategoryId)
    const [enabledSlot6, variablesSlot6] = usePricingModelFeatureSlot(SLOT_ITERATEE[5], categoryId, subCategoryId)

    const slots = [
        { enabled: enabledSlot1, variables: variablesSlot1 },
        { enabled: enabledSlot2, variables: variablesSlot2 },
        { enabled: enabledSlot3, variables: variablesSlot3 },
        { enabled: enabledSlot4, variables: variablesSlot4 },
        { enabled: enabledSlot5, variables: variablesSlot5 },
        { enabled: enabledSlot6, variables: variablesSlot6 },
    ]

    const slotEnabled = findIndex(
        [enabledSlot1, enabledSlot2, enabledSlot3, enabledSlot4, enabledSlot5, enabledSlot6],
        (slot) => slot === true,
    )

    return slotEnabled !== -1 ? slots[slotEnabled] : { enabled: false, variables: undefined }
}

export default usePricingFeatureSlots
